import { createSelector } from '@reduxjs/toolkit';

import { VIDEO_TOOLS_ACCESS } from 'constants/scopes';

import { selectThumbnailFlow } from './editor';
import { selectUserScopes } from './scopes';
import { selectEmojiOrCommentOnBar } from './videoPlayer';
import { daysAgo } from '../../../shared/utilities/time';

export const selectShareVideo = state => state.share_video;

export const selectVideo = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video
);
export const selectUserIsOwner = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.current_user_is_owner
);
export const selectShowAnalyticsToViewer = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video.show_analytics_to_viewer
);
export const selectVideoBelongsToTeam = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video_is_team_shared
);
export const selectVideoUseEmojis = createSelector(
  selectVideo,
  video => video.use_emojis
);
export const selectVideoViews = createSelector(
  selectVideo,
  video => video.views
);

export const selectUserCanACLEditVideo = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.currentUserCanEdit
);
export const selectRecordingClient = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video.video_properties.recordingClient
);
export const selectCtaEnabled = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.cta_enabled
);
export const selectVideoDuration = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video.video_properties.duration
);
export const selectVideoDescription = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video.description
);
export const selectVideoId = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video?.id
);

export const selectCtaConfig = createSelector(selectShareVideo, shareVideo => ({
  ctaMods: shareVideo.cta_mods,
  ctaUrl: shareVideo.cta_url,
  ctaText: shareVideo.cta_text,
}));

export const selectDrawSharepageControlBar = createSelector(
  selectEmojiOrCommentOnBar,
  selectThumbnailFlow,
  (emojiOrCommentOnBar, thumbnailFlow) => !thumbnailFlow && emojiOrCommentOnBar
);

export const selectShareVideoScopes = createSelector(
  selectUserScopes,
  scopes => ({
    hasVideoToolsAccessScope: scopes.includes(VIDEO_TOOLS_ACCESS),
  })
);

export const selectShareVideoWorkspacePlan = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video?.videoWorkspacePlan
);

export const selectShareVideoWorkspacePersona = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video?.videoWorkspacePersona?.persona_v1
);

export const selectDownloadUrl = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.download_url
);

export const selectInTrimMode = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.in_trim_mode
);

export const selectEligibleForWaveform = createSelector(
  selectShareVideo,
  shareVideo =>
    shareVideo.current_user_is_owner && daysAgo(shareVideo.video.createdAt) < 1
);

export const selectAnonymousUsername = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.anonymousUsername
);

export const selectAnonCreatorMode = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.anonCreatorMode
);
